import { OOBE_NS } from "./types";
import { AppState } from "../store";

export const oobeNsSelector = (state: AppState) => state[OOBE_NS];
